import { Link } from 'react-router';
import type { FleetMachine, Machine, NodeTrustInfo } from '@orgus/protocol';
import { cn } from '@orgus/ui';
import { useDataSharing } from '../policy/useDataSharing.ts';
import { aboutAgent } from './about-model.ts';

/** What runs on this machine and why: process, start entry, folder, listener, ceiling, identity and data sent (WP-15). */
export function AboutAgent({ machine, fleet, trust }: { machine: Machine; fleet: FleetMachine | null; trust: NodeTrustInfo | null }) {
  const data = useDataSharing();
  const rows = aboutAgent(machine, fleet, trust, data.state.kind === 'ready' ? data.state.data : null);
  return (
    <section aria-label="About this agent" className="flex flex-col gap-3">
      <h3 className="flex items-center text-ui font-medium text-fg-muted">
        <span className="flex-1">About this agent</span>
        <Link to="/settings/data-sent" className="text-caption font-normal text-fg-subtle underline-offset-2 hover:text-fg hover:underline">
          Data settings
        </Link>
      </h3>
      <dl className="flex flex-col divide-y divide-border-subtle rounded-card border border-border">
        {rows.map((r) => (
          <div key={r.label} className="flex gap-4 px-3 py-2 text-caption">
            <dt className="w-24 shrink-0 text-fg-subtle">{r.label}</dt>
            <dd className={cn('min-w-0 flex-1 break-words text-fg', r.mono && 'font-mono')}>{r.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
